import { PageSize } from '@/constant';
import {
	GetForeignProgramApplicantListParams,
	GetWorkerProgramListParams,
} from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IForeignProgramApplicantDetailStore,
	IForeignProgramDetailStore,
	IForeignProgramListDetailStore,
	IPayloadGetForeignProgramApplicantListRequest,
	IPayloadGetForeignProgramApplicantListSuccess,
	IPayloadGetForeignProgramDetailRequest,
	IPayloadGetForeignProgramDetailSuccess,
	IPayloadGetForeignProgramListRequest,
	IPayloadGetForeignProgramListSuccess,
} from './foreign-program.type';

const InitParams: GetWorkerProgramListParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};

const InitApplicantParams: GetForeignProgramApplicantListParams = {
	page: 1,
	pageSize: PageSize.S,
	name: '',
};

const initialState = {
	fetching: false,
	foreignProgramList: [] as IForeignProgramListDetailStore[],
	total: 0,
	params: InitParams,

	foreignProgramDetail: {} as IForeignProgramDetailStore,

	applicantParams: InitApplicantParams,
	applicantList: [] as IForeignProgramApplicantDetailStore[],
	totalApplicantList: 0,
};

const foreignProgramSlice = createSlice({
	initialState,
	name: 'foreignProgram',
	reducers: {
		/**---- GET FOREIGN_PROGRAM LIST START ---- */
		getForeignProgramListRequest: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramListRequest>
		) => {
			state.fetching = true;
			state.params = action?.payload;
		},
		getForeignProgramListSuccess: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.foreignProgramList = content;
			state.total = total;
		},
		getForeignProgramListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.foreignProgramList = [];
		},
		/**---- GET FOREIGN_PROGRAM LIST END ---- */

		/**---- GET FOREIGN_PROGRAM DETAIL START ---- */
		getForeignProgramDetailRequest: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramDetailRequest>
		) => {
			state.fetching = true;
		},
		getForeignProgramDetailSuccess: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramDetailSuccess>
		) => {
			const { foreignProgramDetail } = action.payload;
			state.fetching = false;
			state.foreignProgramDetail = foreignProgramDetail;
		},
		getForeignProgramDetailFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET FOREIGN_PROGRAM DETAIL END ---- */

		/**---- GET FOREIGN_PROGRAM PROGRAM APPLICANT LIST START ---- */
		getForeignProgramApplicantListRequest: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramApplicantListRequest>
		) => {
			const { params } = action.payload;
			state.fetching = true;
			state.applicantParams = params;
		},
		getForeignProgramApplicantListSuccess: (
			state,
			action: PayloadAction<IPayloadGetForeignProgramApplicantListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.applicantList = content;
			state.totalApplicantList = total;
		},
		getForeignProgramApplicantListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.applicantList = [];
		},
		/**---- GET FOREIGN_PROGRAM PROGRAM APPLICANT LIST END ---- */
	},
});

export const ForeignProgramSelectors = {
	selectFetching: (state: RootState) => state.foreignProgram.fetching,
	selectParams: (state: RootState) => state.foreignProgram.params,
	selectTotal: (state: RootState) => state.foreignProgram.total,
	selectList: (state: RootState) => state.foreignProgram.foreignProgramList,

	selectDetail: (state: RootState) => state.foreignProgram.foreignProgramDetail,

	selectApplicantTotal: (state: RootState) =>
		state.foreignProgram.totalApplicantList,
	selectApplicantListParams: (state: RootState) =>
		state.foreignProgram.applicantParams,
	selectApplicantList: (state: RootState) => state.foreignProgram.applicantList,
};

export const ForeignProgramActions = foreignProgramSlice.actions;
export const ForeignProgramReducer = foreignProgramSlice.reducer;
